/**
 * The backend's refusal of a set of design points - a manual start or an
 * injected generation (colorExplorer/manual_start.py DesignPointsError,
 * ``{ error, code, details }``): the message and, per refused cell, the
 * sample, the parameter, the value and the nearest allowed value. Details
 * without a sample row (a count mismatch) are covered by the message.
 */
import React from "react";
import { Alert, Box } from "@mui/material";

const PARAMETER_LABELS = {
  power: "Power",
  speed: "Speed",
  frequency: "Frequency",
  pulse_duration: "Pulse duration",
  hatching: "Hatching",
  line_count: "Line count",
  pass_count: "Pass count",
};

export function parameterLabel(name) {
  return PARAMETER_LABELS[name] || name;
}

export default function DesignPointsErrorAlert({ error, fallback }) {
  if (!error) return null;
  const details = (Array.isArray(error.details) ? error.details : []).filter(
    (detail) => detail && detail.row != null
  );
  return (
    <Alert severity="error" sx={{ py: 0.5 }}>
      {error.error || fallback}
      {details.length > 0 ? (
        <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
          {details.map((detail, index) => (
            <li key={index}>
              {`Sample ${detail.row + 1}`}
              {detail.parameter ? `, ${parameterLabel(detail.parameter)}` : ""}
              {detail.value != null ? ` = ${detail.value}` : ""}
              {detail.nearest != null ? ` (nearest ${detail.nearest})` : ""}
              {detail.duplicate_of != null ? ` duplicates sample ${detail.duplicate_of + 1}` : ""}
              {detail.code ? ` — ${detail.code}` : ""}
            </li>
          ))}
        </Box>
      ) : null}
    </Alert>
  );
}
